import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "public/environments/environment";
import { LookupsService } from 'projects/shared/src/services/lookups.service';
import { IMenuItem, NavigationService } from 'projects/shared/src/services/navigation.service';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';
import { User } from 'projects/shared/src/models/auth';

@Component({
  selector: 'app-sidebar',
  standalone: false,
  templateUrl: './sidebar.component.html',
  // animations: [
  //   trigger('contentExpansion', [
  //     state('expanded', style({ height: '*', opacity: 1, visibility: 'visible' })),
  //     state('collapsed', style({ height: '0px', opacity: 0, visibility: 'hidden' })),
  //     transition('expanded <=> collapsed',
  //       animate('200ms cubic-bezier(.37,1.04,.68,.98)')),
  //   ])
  // ]
})
export class SidebarComponent implements OnInit {
  nav: IMenuItem[] = [];
  selectedItem: IMenuItem | null = null;
  appRedirectUrl = environment.appRedirectSiteUrl;
  currentUser: User | any = new User();

  constructor(
    public navService: NavigationService,
    public LookupsService: LookupsService,
    public authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit(): void {
    // this.navService.menuItems.subscribe(items => {
    //   this.nav = items;
    // });
    this.getMenuItems();
    // if ((location.href.includes("localhost") || location.href.includes("diwandev")) && !environment.apiUrl.includes('test')) {
    //   this.navService.menuItems.subscribe(items => {
    //     this.nav = items;
    //   });
    // } else {
    //   this.getMenuItems();
    // }
  }
  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }


  getMenuItems() {
    this.LookupsService.GetMenu().subscribe(
      (data: any) => {
        this.nav = data as IMenuItem[];
        // this.nav.map(item => {
        //   item.title = item.name;
        //   item.type = item.childs && item.childs.length ? 'dropDown' : 'link';
        //   item.icon = item.svg;
        //   item.state = item.url;
        //   if (item.childs && item.childs.length) {
        //     item.sub = item.childs;
        //     item.sub.map((child: any) => {
        //       child.title = child.name;
        //       child.type = 'link';
        //       child.icon = child.svg;
        //       child.state = child.url;
        //     });
        //   }
        // })
        // this.authenticationService.menuLoaded.next(this.nav);
      },
      (error: any) => {
        this.authenticationService.logout();
      });
  }
  isActiveMenu(link: string): boolean {
    if (!link) return false;

    // Turn whatever you passed—full URL or path—into a clean pathname:
    let linkPath: string;
    try {
      // If it's a full URL, this will work; if not, it throws:
      linkPath = new URL(link, window.location.origin).pathname;
    } catch {
      // Fallback: assume it's already a relative path (with or without leading slash)
      linkPath = link.startsWith("/") ? link : `/${link}`;
    }

    const path = window.location.pathname;

    // Exact match
    if (path === linkPath) {
      return true;
    }

    // Prefix match only if followed by a slash (so "/admin/rights" ✅ but
    // "/admin/rights-console" ❌)
    return path.startsWith(linkPath + "/");
  }

  selectItem(item: IMenuItem) {
    if (item.active) {
      this.nav.forEach(element => {
        element.active = false;
      });
      this.selectedItem = null;
    } else {
      this.selectedItem = item;
      this.setActiveMainItem(item);
    }
  }

  setActiveMainItem(item: IMenuItem) {
    this.nav.forEach(element => {
      element.active = false;
    });
    item.active = true;
  }

  toggelSidebar() {
    const navState = this.navService.sidebarState;
    navState.sidenavOpen = !navState.sidenavOpen;
  }

}
